import { HelpPlanTypeModel } from './help-plan-type.model';
import { HelpPlanDetailsModel } from './helpPlanDetails.model';

export class IntakeHelpPlansModel {
    hplId: string = null;
    hplName: string = null;
    hplCode: string = null;
    hplIsInIntake: boolean = null;
    helpPlanDetails: HelpPlanDetailsModel = new HelpPlanDetailsModel();
    helpPlanTypeIds: any = null;
}